module.exports = __webpack_public_path__ + "media/transport_protocols/Settings-fb86f1d6.svg";